<div class="counter" [ngClass]="style">
  <h5 class="title">{{ title }}</h5>
  <p class="description" [innerHTML]="description"></p>

  <div ace-editor [(text)]="code"></div>
</div>
